import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientSelfAssessmentList = createAsyncThunk("client/get-self-assessment", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-self-assessment`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.clientChildIssue);
    return res.data.selfAssessment;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client self assessment");
  }
});

export const getClientSelfAssessment = createAsyncThunk("client/get-clientself-assessment", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-clientself-assessment`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.clientChildIssue);
    return res.data.selfAssessment;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client self assessment");
  }
});

export const updateClientSelfAssessment = createAsyncThunk(
  "client/update-clientself-assessment",
  async ({ token, options }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/client/update-clientself-assessment`,
        options,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update client self assessment"
      );
    }
  }
);


const clientSelfAssessmentSlice = createSlice({
  name: "clientSelfAssessment",
    initialState: {
      clientsSelfAssessmentQuestions: null,
      clientsSelfAssessmentAnswer: null,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientSelfAssessmentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientSelfAssessmentList.fulfilled, (state, action) => {
            state.clientsSelfAssessmentQuestions = action.payload;
            state.loading = false;
        })
        .addCase(getClientSelfAssessmentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client self assessment"; 
            state.loading = false;
        })
        .addCase(getClientSelfAssessment.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientSelfAssessment.fulfilled, (state, action) => {
            state.clientsSelfAssessmentAnswer = action.payload;
            state.loading = false;
        })
        .addCase(getClientSelfAssessment.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client self assessment"; 
            state.loading = false;
        })
    },
});

export default clientSelfAssessmentSlice.reducer;